import { AcademicCalendar } from "@examspark/types";

export const getFormattedStartEndYearsForCalendar = (
  calendar?: AcademicCalendar | null,
) => {
  if (!calendar) return;
  const startYear = calendar.startAt.substring(2, 4);
  const endYear = calendar.endAt.substring(2, 4);

  const years = Array.from(new Set([startYear, endYear]));
  return years.join("/");
};

export const gradingPeriodLengthsProps: Record<string, { label: string }> = {
  "6_WEEKS": {
    label: "6 Week",
  },
  "9_WEEKS": {
    label: "9 Week",
  },
};
